// バックエンド確認用
// export const apiEndPoint = process.env.REACT_APP_APIENDPOINT_BACKEND_DEV;

// フロントエンド開発用
export const apiEndPoint = process.env.REACT_APP_APIENDPOINT_DEV;
